export enum AccountRole {
    OWNER = 'owner',
    ADMIN = 'admin',
    MANAGER = 'manager',
    OTHER = 'other',
    SUPPORT = 'support'
}
